import { defineSlotRecipe } from '@chakra-ui/react';
import { inputRecipe } from '@theme/recipes/input.recipe';
import { defaultVariant } from '@theme/variants/input/default.variant';

export const comboboxSlotRecipe = defineSlotRecipe({
  className: 'chakra-combobox',
  slots: ['root', 'control', 'input', 'indicatorGroup', 'clearTrigger', 'positioner', 'content', 'empty', 'item'],
  base: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      width: 'full',
    },

    input: inputRecipe.base,

    clearTrigger: {
      cursor: 'pointer',
      boxSize: '24px',
      color: 'neutral.300',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    control: {
      padding: 0,
      height: 'inherit',
      width: 'inherit',
      border: 'none',
    },

    indicatorGroup: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1,
      pos: 'absolute',
      insetEnd: '0',
      top: '0',
      bottom: '0',
      px: 'var(--combobox-input-padding-x)',
      _icon: {
        boxSize: 'var(--combobox-indicator-size)',
      },
      '[data-disabled] &': {
        opacity: 0.5,
      },
    },

    positioner: {
      maxHeight: '528px',
    },

    content: {
      borderRadius: 'none',
      backgroundColor: 'neutral.900-op80',
      border: '2px solid',
      paddingX: '0 !important',
      paddingY: '0 !important',
      borderColor: 'neutral.black',
      '&::-webkit-scrollbar': {
        width: '10px',
      },
      '&::-webkit-scrollbar-track': {
        background:
          'linear-gradient(to right, var(--chakra-colors-neutral-black) 20%, var(--chakra-colors-neutral-850) 20%, var(--chakra-colors-neutral-850) 100%)',
      },
      '&::-webkit-scrollbar-thumb': {
        cursor: 'pointer',
        background:
          'linear-gradient(to right, transparent 20%, var(--chakra-colors-neutral-600) 20%, var(--chakra-colors-neutral-600) 100%)',
        width: '10px',
      },
      maxHeight: '528px',
    },

    item: {
      borderRadius: 'none',
      backgroundColor: 'neutral.800',
      border: '2px solid',
      borderColor: 'neutral.800',
      cursor: 'pointer',
      height: '48px',
      maxHeight: '48px',
      _hover: {
        borderColor: 'skyBlue',
        backgroundColor: 'neutral.700',
      },
      '&[data-highlighted]': {
        borderColor: 'skyBlue',
        backgroundColor: 'neutral.800',
      },
      '&[data-state="checked"]': {
        backgroundColor: 'blue',
        borderColor: 'blue',
        _hover: {
          borderColor: 'skyBlue',
          backgroundColor: 'blue',
        },
      },
    },

    empty: {
      borderRadius: 'none',
      backgroundColor: 'neutral.800',
      border: '2px solid',
      borderColor: 'neutral.800',
    },
  },

  variants: {
    variant: {
      default: {
        input: defaultVariant,
      },
    },

    size: {
      sm: {
        root: {
          height: '48px',
        },
        input: {
          textStyle: 'sm',
          height: '48px',
          padding: 2,
        },
      },
    },
  },

  defaultVariants: {
    size: 'sm',
    variant: 'default',
  },
});
